import { axios } from '@/plugins/axios';
import { Pagination, Statement, Resource } from "@/helpers/Interfaces";
import { Seen } from '@/modules/logito/office/services/RegisterService';
import Pager from '@/helpers/Pager';
import { merge } from 'lodash';

export default class ParticipantsService
{
    public static async markShareAsRead(licence: string, documentId: string): Promise<Statement>
    {
        return (await axios.put(`${licence}/${documentId}/participants/mark-share-as-read`)).data;
    }

    public static async markShareDocsAsRead(licence: string, documentIds: string[]): Promise<Statement>
    {
        return (await axios.put(`${licence}/participants/mark-share-as-read`, documentIds)).data;
    }

    public static async getTargetVisits(licence: string, documentId: string, historyId: number, targetMemberType: number, targetMemberId: number, onlySeen: boolean): Promise<Pagination<Resource<Seen>>>
    {
        const pager = new Pager(1, 999);

        return (await axios.get<Pagination<Resource<Seen>>>(`simple-query/${licence}/${documentId}/history-visits`, {
            params: merge({}, pager.data(), {
                historyId,
                targetMemberType,
                targetMemberId,
                onlySeen,
            })
        })).data;
    }

    public static async exportReadStatusToExcel(licence: string, documentId: string): Promise<File>
    {
        return (
            await axios.get(`${licence}/${documentId}/participants/read-status-excel`, {
                responseType: 'blob',
            })
        ).data;
    }
}
